(function(){
    angular
        .module('appback')
        .directive('ngAnaliticaresultado', analiticaresultado);

        analiticaresultado.$inject = ['ResultadosService','$timeout'];
        function analiticaresultado(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/resultadopeticion/templateresultados?name=resultadoanalitica.twig',
		          scope: {
                  //ngModel : '=',
                  peticion: '=',
                  categoria: '=',
                  rc: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        //console.log("anres",scope);
		            	//console.log("resultado");
			        });
		        }
          }
      }
})();